import { ComparisonRow } from '../types'

export const comparisonRows: ComparisonRow[] = [
  {
    criterion: 'Chemicals in the water',
    hydrosprings: 'None',
    salt: 'Generates chlorine',
    uvOzone: 'Chlorine still required',
    ionizer: 'Copper residual',
  },
  {
    criterion: 'pH management',
    hydrosprings: 'Naturally held at 7.2\u20137.6',
    salt: 'Drifts high, manual acid',
    uvOzone: 'Manual',
    ionizer: 'Manual',
  },
  {
    criterion: 'Algae & bacteria control',
    hydrosprings: 'Full body of water',
    salt: 'Full, via chlorine',
    uvOzone: 'Only water passing the lamp',
    ionizer: 'Slow, partial',
  },
  {
    criterion: 'Effect on skin, eyes & hair',
    hydrosprings: 'None reported',
    salt: 'Dryness, irritation',
    uvOzone: 'Irritation from chlorine',
    ionizer: 'Possible staining',
  },
  {
    criterion: 'Owner effort',
    hydrosprings: 'Minimal \u2014 no testing or dosing',
    salt: 'Weekly testing & dosing',
    uvOzone: 'Weekly dosing + lamp swaps',
    ionizer: 'Constant monitoring',
  },
  {
    criterion: 'Drinking-water standard',
    hydrosprings: 'Meets EPA standards',
    salt: 'No',
    uvOzone: 'No',
    ionizer: 'No',
  },
]
